import { IBusinessFunction } from "../interfaces/ibusinessfunction";
import { IUser } from "../interfaces/ilogin";
import * as loadingActions from "../actions/loading.action";

export interface ILoading {
    loading: boolean;
    surpressLoading: boolean;
}

const initialState: ILoading = {
    loading: false,
    surpressLoading:  false
};

export function loadingReducer(state: ILoading = initialState, action: loadingActions.Actions): ILoading {
    switch (action.type) {
        case loadingActions.actionTypes.SHOW_LOADING:
            return {
                ...state,
                loading: true
            };
        case loadingActions.actionTypes.HIDE_LOADING:
            return {
                ...state,
                loading: false
            };
        case loadingActions.actionTypes.SURPRESS_LOADING:
            return {
                ...state,
                surpressLoading: true
            };
        case loadingActions.actionTypes.UNSURPRESS_LOADING:
            return {
                ...state,
                surpressLoading: false
            };
        default:
            return state;
    }
}